/* eslint-disable func-names */
import EDC from '../../../shared/globals';

EDC.Animations.Question = function (scene) {
  this.scene = scene;
  this.questionMark = null;
};

EDC.Animations.Question.prototype.create = function (x, y) {
  this.questionMark = this.scene.add.sprite(x, y, 'question-mark');
  this.questionMark.play('question-blinking');
};

EDC.Animations.Question.prototype.moveTo = function (newX, newY) {
  this.scene.tweens.add({
    targets: this.questionMark,
    x: newX + this.questionMark.width / 2,
    y: newY,
    duration: 180,
    ease: 'Linear',
  });
};

EDC.Animations.Question.prototype.show = function () {
  this.questionMark.setAlpha(1);
};

EDC.Animations.Question.prototype.hide = function () {
  this.questionMark.setAlpha(0);
};

export default EDC.Animations.Question;
